import React, { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const KEY = "tc-theme";

export default function ThemeToggle({ compact = false }) {
  const [dark, setDark] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    const initial = stored ? stored === "dark" : window.matchMedia?.("(prefers-color-scheme: dark)").matches;
    setDark(initial);
    document.documentElement.classList.toggle("dark", initial);
  }, []);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem(KEY, next ? "dark" : "light");
  };

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle-btn"
      aria-label="Toggle dark mode"
      className={`flex items-center gap-2 rounded-lg transition-colors hover:bg-muted ${compact ? "p-1.5" : "px-3 py-2 text-sm"} text-foreground/70 hover:text-foreground`}
    >
      {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      {!compact && <span>{dark ? "Light" : "Dark"} mode</span>}
    </button>
  );
}
